import api from './core/api';

export interface MediaItem {
  id: string;
  filename: string;
  originalName: string;
  mimeType: string;
  size: number;
  width?: number;
  height?: number;
  url: string;
  thumbnailUrl?: string;
  alt?: string;
  title?: string;
  description?: string;
  entityType: string;
  entityId: string;
  createdAt: string;
  updatedAt: string;
}

interface UploadResponse {
  success: boolean;
  data: MediaItem[];
  message?: string;
}

export const mediaService = {
  // Upload multiple images
  async uploadImages(files: File[], entityType: string, entityId: string): Promise<MediaItem[]> {
    const formData = new FormData();
    
    // Add files to form data
    files.forEach((file) => {
      formData.append('images', file);
    });
    
    // Add metadata
    formData.append('entityType', entityType);
    formData.append('entityId', entityId);

    const response = await api.post<UploadResponse>('/admin/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },

  // Get media by entity
  async getMediaByEntity(entityType: string, entityId: string): Promise<MediaItem[]> {
    const response = await api.get<{ success: boolean; data: MediaItem[] }>(
      `/admin/media/entity/${entityType}/${entityId}`
    );
    return response.data.data;
  },

  // Get media by ID
  async getMedia(id: string): Promise<MediaItem> {
    const response = await api.get<{ success: boolean; data: MediaItem }>(
      `/admin/media/${id}`
    );
    return response.data.data;
  },

  // Update media metadata
  async updateMedia(
    id: string,
    data: {
      alt?: string;
      title?: string;
      description?: string;
    }
  ): Promise<MediaItem> {
    const response = await api.put<{ success: boolean; data: MediaItem }>(
      `/admin/media/${id}`,
      data
    );
    return response.data.data;
  },

  // Delete media
  async deleteMedia(id: string): Promise<void> {
    await api.delete(`/admin/media/${id}`);
  },
};

export default mediaService;